//import React, { useEffect, useState } from "react";
import "./OrderDetails.css";

const OrderDetails = ({ selectedOrder }) => {
  if (!selectedOrder) {
    return (
      <div className="order-container">
        <h2 className="order-title">Order Details</h2>
        <hr />
        <div
          className="order-content empty-state"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "80%",
          }}
        >
          <span style={{ color: "#A3A3A3", fontSize: "18px" }}>
            Select an order to see details
          </span>
        </div>
      </div>
    );
  }

  const orderItems = selectedOrder.items || [];
  const subTotal = orderItems.reduce((acc, item) => acc + item.price, 0);
  const gst = subTotal * 0.05;
  const roundOff = Math.round(gst);
  const grandTotal = subTotal + roundOff;
 
  return (
    <div className="order-container">
      <h2 className="order-title">Order Details</h2>
      <hr />
      <div className="order-content">
        {orderItems.map((item, index) => (
          <div key={index} className="order-item">
            <span className="item-name">{item.name}</span>
            <span className="item-quantity">{item.quantity}</span>
            <span className="item-price">₹{item.price}</span>
          </div>
        ))}
      </div>
      <hr />
      <div className="order-summary">
        <div className="summary-item">
          <span>Sub Total</span>
          <span>₹{subTotal.toFixed(2)}</span>
        </div>
        <div className="summary-item">
          <span>GST(5%)</span>
          <span>₹{gst.toFixed(2)}</span>
        </div>
        <div className="summary-item">
          <span>Cash Round off</span>
          <span>₹{roundOff}</span>
        </div>
        <div className="summary-item grand-total">
          <span>Grand Total</span>
          <span>₹{grandTotal.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;